webpackJsonp([1],{

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueisotope__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueisotope___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vueisotope__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Node__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Node___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Node__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Work__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_touch__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_touch__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vueisotope___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_touch___default.a, { name: 'v-touch' });

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/:path(projects|projects/.*)?',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Work___default.a
  }, {
    path: '/:title([a-zA-Z][a-zA-Z0-9_-]+)',
    name: 'Node',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Node___default.a
  }]
}));

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ls__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






var options = {
  namespace: 'vuejs__'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_ls___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a, {
  preLoad: 1.3,
  error: '/static/images/loading-wheel.svg',
  loading: '/static/images/loading-wheel.svg',
  attempt: 1
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('edit-link', {
  props: {
    id: 0
  },
  computed: {
    link: function () {
      return "http://www.typeandline.com/" + '/node/' + this.id + '/edit';
    }
  },
  template: '<a class="edit-link" :href="link" target="_blank">Edit</a>'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  appClass: 'static',
  data: {
    menuItems: [],
    siteName: 'typeandline'
  }
});

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function scrollY() {
  if (window.pageYOffset) {
    return window.pageYOffset;
  }
  return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
}

function winWidth() {
  if (document.documentElement && document.documentElement.clientWidth) {
    return document.documentElement.clientWidth;
  }
  if (document.body) {
    return document.body.clientWidth;
  }
}

function isTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function () {
    return {
      init: false,
      alias: 'home',
      title: 'typeandline',
      owner: 'Dominic Dyson',
      strapline: 'indepedent graphic design',
      shuffle: false,
      clearTs: 0,
      straplineShown: false,
      containerClasses: [],
      nodes: [],
      infoLoaded: false,
      isAdmin: false,
      adminUrl: '',
      adminPath: '',
      statusMsg: '',
      showStatusMsg: false,
      hasAdminUrl: false,
      editedChecked: false,
      scrolling: false,
      scrollY: 0,
      prevY: 0,
      prevStopY: 0,
      stop: 0,
      halfWY: 0,
      winHeight: 0,
      winWidth: 0,
      pageHeight: 0,
      user: {},
      menu: [{
        link: '/',
        title: 'Projects'
      }],
      backend: 'http://tal.platform-3.co.uk/'
    };
  },
  created: function () {
    if (__webpack_require__.i({"NODE_ENV":"production","BACKEND":"http://www.typeandline.com/"})) {
      if (true) {
        this.backend = "http://www.typeandline.com/";
      }
    }
    if (window.location.pathname) {
      var pn = window.location.pathname;
      var currHash = window.location.hash;
      if (pn.length < 3 && currHash.length < 3) {
        pn = '/projects';
      }
      if (pn.length > 1) {
        if (typeof history.replaceState === 'function') {
          history.pushState({ mode: pn }, pn, '/');
          if (pn.indexOf('/index.') !== 0) {
            var newHash = '#' + pn;
            if (newHash !== currHash) {
              window.location = newHash;
            }
          }
        }
      }
    }
    this.checkSiteInfo();
    this.updateWrapperClass();
    if (isTouchDevice()) {
      this.addContainerClass('touch-enabled');
    }
    this.checkLoggedin();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleKeys);
    this.handleResize(true);
    var comp = this;
    setTimeout(function () {
      comp.init = true;
      window.addEventListener('hashchange', comp.updateWrapperClass);
    }, 500);
    setTimeout(function () {
      if (!comp.editedChecked) {
        comp.checkEdited();
      }
    }, 30 * 1000);
  },
  watch: {
    adminUrl: function () {
      this.hasAdminUrl = this.adminUrl.length > 3;
      if (this.hasAdminUrl) {
        this.adminPath = 'http://tal.platform-3.co.uk' + this.adminUrl;
        this.addContainerClass('show-admin');
      } else {
        this.adminPath = '';
        this.removeContainerClass('show-admin');
      }
    }
  },
  methods: {
    path: function () {
      return window.location.hash;
    },
    checkLoggedin: function () {
      var comp = this;
      var ts = new Date().getTime();
      this.$http.get(this.backend + 'jsonstyles/user?ts=' + ts).then(function (response) {
        if (response.data) {
          if (typeof comp === 'object') {
            comp.user = response.data;
            if (comp.user.roles) {
              comp.isAdmin = comp.user.is_editor;
              if (this.backend === '/tal/') {
                comp.isAdmin = true;
              }
              if (comp.isAdmin) {
                comp.checkEdited();
              }
            }
          }
        }
      }, function (response) {});
    },
    checkSiteInfo: function () {
      var data = this.$ls.get('sitedata', null);
      var ts = new Date().getTime();
      var prevTs = this.$ls.get('ts');
      if (data !== null) {
        this.loadSiteInfo(data);
      } else {
        var matched = false;
        if ($preload.site_info) {
          if ($preload.site_info.menu) {
            if ($preload.site_info.menu instanceof Array) {
              matched = true;
              this.loadSiteInfo($preload.site_info);
            }
          }
        }
        if (!matched) {
          this.fetchSiteInfo(ts);
        }
      }
      if (ts - prevTs > 15 * 60 * 1000) {
        var comp = this;
        setTimeout(function () {
          comp.fetchSiteInfo(ts);
        }, 5000);
      }
    },
    fetchSiteInfo: function (ts) {
      var comp = this;
      this.$http.get(this.backend + 'jsonstyles/siteinfo').then(function (response) {
        if (response.data) {
          if (typeof response.data === 'object') {
            comp.loadSiteInfo(response.data);
            comp.$ls.set('sitedata', response.data, 7 * 24 * 60 * 60 * 1000);
            this.$ls.set('ts', ts);
          }
        }
      }, function (response) {});
    },
    loadSiteInfo: function (data) {
      if (data.site_name) {
        this.title = data.site_name;
      }
      if (data.menu) {
        this.menu = data.menu;
      }
      if (data.owner) {
        this.owner = data.owner;
      }
      if (data.strapline) {
        this.strapline = data.strapline;
      }
      if (data.shuffle) {
        this.shuffle = data.shuffle === 1;
      }
      if (data.nodes && data.nodes instanceof Array) {
        this.nodes = data.nodes;
        var comp = this;
        setTimeout(function () {
          var alias = window.location.hash.replace(/^#/, '');
          var otherNodes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(comp.nodes, function (n) {
            return n.alias !== alias && n.alias.indexOf('/projects') !== 0;
          });
          if (otherNodes.length > 0) {
            for (var i = 0; i < otherNodes.length; i++) {
              comp.getNode(otherNodes[i].nid, null, true);
            }
          }
        }, 1000);
        this.infoLoaded = true;
      }
    },
    checkEdited: function () {
      this.$http.get(this.backend + 'jsonstyles/edited').then(function (response) {
        if (response.data) {
          if (typeof response.data === 'object') {
            if (response.data.nodes) {
              this.$ls.set('editednodes', response.data);
              var sd = this.$ls.get('sitedata');
              var comp = this;
              if (sd) {
                if (sd.nodes) {
                  __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(response.data.nodes, function (n) {
                    var isProject = /^\/?projects\//.test(n.alias);
                    var n2 = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(sd.nodes, function (sn) {
                      return n.nid === sn.nid;
                    });
                    var changed = true;
                    if (n2 !== undefined) {
                      if (n2.changed) {
                        changed = parseInt(n.changed) > parseInt(n2.changed);
                      }
                    }
                    if (changed) {
                      if (isProject) {
                        comp.$ls.remove('projects-full');
                        comp.$ls.remove('projects-full-more');
                      } else {
                        comp.$ls.remove('node-full/' + n.nid);
                      }
                    }
                  });
                }
              }
              this.editedChecked = true;
            }
          }
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getNode: function (nid, callback) {
      var refName = 'node-full/' + nid;
      var data = this.$ls.get(refName, null);
      var edited = this.$ls.get('editednodes');
      if (edited) {
        if (edited.total && data !== null) {
          if (edited.total > 0) {
            var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(edited.nodes, function (n) {
              return n.nid === nid;
            });
            if (index >= 0) {
              if (edited.nodes[index]) {
                var n = edited.nodes[index];
                if (n.changed > data.changed) {
                  data = null;
                }
              }
            }
          }
        }
      }
      if (data !== null) {
        if (callback) {
          callback(data);
        }
      } else {
        var plRef = refName.replace(/\//g, '__').replace(/-/g, '_');
        var matched = false;
        if ($preload) {
          if ($preload[plRef]) {
            if ($preload[plRef].valid) {
              if (callback) {
                callback($preload[plRef]);
              }
              matched = true;
            }
          }
        }
        if (!matched) {
          this.fetchNode(refName, callback);
        }
      }
    },
    fetchNode: function (refName, callback, preFetch) {
      var comp = this;
      this.$http.get(this.backend + 'jsonstyles/' + refName).then(function (response) {
        if (response.data instanceof Object) {
          comp.$ls.set(refName, response.data, 24 * 60 * 60 * 1000);
          if (callback) {
            callback(response.data, refName);
          }
        }
      }, function (response) {
        if (preFetch !== true) {
          console.log("404 not found");
        }
      });
    },
    calcPageHeight: function () {
      var B = document.body;
      var H = document.documentElement;
      return Math.max(B.scrollHeight, B.offsetHeight, H.clientHeight, H.scrollHeight, H.offsetHeight);
    },
    scrollTo: function (offsetY, reset) {
      if (this.scrolling === false) {
        this.scrolling = true;
        var comp = this;
        this.$scrollTo('body', 250, {
          offset: offsetY,
          easing: 'ease-in',
          cancelable: true,
          onDone: function () {
            comp.scrolling = false;
          },
          onCancel: false
        });
        if (!reset) {
          reset = 1000;
        }
        setTimeout(function () {
          comp.scrolling = false;
        }, reset);
      }
    },
    handleScroll: function () {
      this.scrollY = scrollY();
      if (this.stopY > 0) {
        if (this.scrollY > this.prevY + this.stopY || this.scrollY < this.prevY - this.stopY) {
          this.prevStopY = this.prevY;
          this.prevY = this.scrollY;
          var sdClassIndex = this.containerClasses.indexOf('scrolled-down');
          if (this.scrollY > this.winHeight / 16) {
            if (sdClassIndex < 0) {
              this.addContainerClass('scrolled-down');
              this.straplineShown = true;
            }
          } else {
            if (sdClassIndex >= 0) {
              if (this.straplineShown === true) {
                this.removeContainerClass('show-top-info');
              }
              this.removeContainerClass('scrolled-down');
            }
          }
        }
      }
    },
    handleResize: function (init) {
      this.pageHeight = this.calcPageHeight();
      this.winHeight = window.innerHeight;
      this.winWidth = winWidth();
      if (init === true) {
        this.stopY = this.winHeight / 64;
        this.halfWY = this.winHeight / 2;
      }
    },
    revealStrapline: function () {
      this.straplineShown = false;
      this.updateWrapperClass();
    },
    handleKeys: function (e) {
      var alias = window.location.hash.replace(/^#/, '');
      switch (e.keyCode) {
        case 27:
          if (/\/projects\/\w+/.test(alias)) {
            window.location = '#/projects';
          }
          break;
        case 37:
          window.history.back();
          break;
        case 39:
          window.history.forward();
          break;
      }
    },
    updateWrapperClass: function (e) {
      var hash = window.location.hash;
      var wrapperClass = 'home';
      if (hash.length > 2) {
        var parts = hash.split('/');
        parts.shift();
        if (parts.length > 0) {
          wrapperClass = parts.join('-');
        }
      }
      this.removeContainerClass('show-top-info');
      this.removeContainerClass('show-menu');
      var i = 0;
      var cls = [];
      var cl;
      for (; i < this.containerClasses.length; i++) {
        cl = this.containerClasses[i];
        if (/^(project|home|contact|about)/.test(cl) === false) {
          cls.push(cl);
        }
      }
      this.containerClasses = cls;
      this.addContainerClass(wrapperClass);
      switch (wrapperClass) {
        case 'info':
        case 'about':
        case 'contact':
          this.straplineShown = false;
          break;
      }
      if (this.straplineShown !== true && /projects-\w+/.test(wrapperClass) === false) {
        this.addContainerClass('show-top-info');
        this.straplineShown = true;
        var comp = this;
        setTimeout(function () {
          comp.straplineShown = false;
        }, 15 * 60 * 1000);
      }
    },
    menuToggle: function () {
      var index = this.containerClasses.indexOf('show-menu');
      if (index < 0) {
        this.containerClasses.push('show-menu');
      } else {
        this.containerClasses.splice(index, 1);
      }
    },
    clearLocalStorage: function () {
      if (this.isAdmin) {
        var ts = Math.floor(new Date().getTime() / 1000);
        if (ts - 5 > this.clearTs) {
          this.$ls.clear();
          this.clearTs = ts;
          this.checkSiteInfo();
          this.statusMsg = 'Local caches cleared';
          this.showStatusMsg = true;
          switch (this.alias) {
            case 'home':
              this.$emit('reload-projects');
              break;
          }
          var comp = this;
          setTimeout(function () {
            comp.showStatusMsg = false;
          }, 2000);
          setTimeout(function () {
            comp.statusMsg = '';
          }, 3000);
        }
      }
    },
    addContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'add');
    },
    removeContainerClass: function (clsName) {
      this.toggleContainerClass(clsName, 'rem');
    },
    toggleContainerClass: function (clsName, mode) {
      var index = this.containerClasses.indexOf(clsName);
      if (mode === 'add' && index < 0) {
        this.containerClasses.push(clsName);
      } else if (index >= 0) {
        switch (mode) {
          case 'rem':
          case 'remove':
            this.containerClasses.splice(index, 1);
            break;
        }
      }
    },
    closeAdmin: function () {
      this.adminUrl = '';
      this.checkEdited();
    },
    slidesRefName: function (more) {
      var refName = 'projects-full';
      if (more) {
        refName += '-more';
      }
      return refName;
    }
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'node',
  directives: {
    scrollTo: __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a
  },
  components: {},
  props: {
    isAdmin: false
  },
  data: function () {
    return {
      title: 'About',
      showTitle: false,
      hasContent: false,
      content: {},
      nodes: [],
      loading: false,
      fillPicCalled: false,
      fullSizes: {
        'max_2600x2600': '(min-width:1301px)',
        'max_1300x1300': '(min-width:651px) and (max-width:1300px)',
        'max_650x650': '(max-width:650px)'
      }
    };
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      vm.initPage();
    });
  },
  created: function () {
    window.addEventListener('hashchange', this.loadPage);
  },
  methods: {
    initPage: function () {
      if (this.$parent.infoLoaded) {
        this.nodes = this.$parent.nodes;
        this.loadPage();
      } else {
        var comp = this;
        setInterval(function () {
          if (comp.$parent.infoLoaded) {
            comp.nodes = comp.$parent.nodes;
            comp.loadPage();
          }
        }, 200);
      }
      this.$parent.scrollTo(0, 250);
    },
    loadPage: function () {
      this.fillPicCalled = false;
      var alias = window.location.hash;
      if (alias.length > 2 && this.loading !== true) {
        alias = alias.replace(/^#/, '');
        var comp = this;
        var index = -1;
        if (alias.indexOf('/projects') !== 0) {
          index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.nodes, function (n) {
            return n.alias === alias;
          });
        }
        if (index >= 0) {
          this.loading = true;
          var node = this.nodes[index];
          this.$parent.getNode(node.nid, function (data) {
            comp.addArticle(data);
            comp.loading = false;
          });
        } else {
          setTimeout(function () {
            comp.addNotFound();
          }, 3000);
        }
      }
    },
    addNotFound: function () {
      if (!this.hasContent) {
        this.title = 'Page not found';
        this.content.body = 'This resource is not available';
        this.content.hasImage = false;
        this.hasContent = true;
        this.showTitle = true;
      }
    },
    addArticle: function (data, refName) {
      if (data.title) {
        this.content = data;
        this.title = data.title;
        this.hasContent = true;
        this.content.hasImage = false;
        this.showTitle = false;
        if (data.image) {
          this.content.hasImage = data.image !== null && data.image.sizes;
        }
      }
      var comp = this;
      setTimeout(function () {
        comp.loading = false;
      }, 250);
    },
    editNode: function (id) {
      this.$parent.adminUrl = '/node/' + id + '/edit';
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function () {
    return {
      id: '',
      playing: false,
      tooltip: 'Play'
    };
  },
  props: {
    media: {},
    autoplay: false
  },
  created: function () {
    if (this.media.uris instanceof Array) {
      if (this.media.uris.length > 0) {
        this.id = this.media.uris[0].src;
      }
    }
  },
  methods: {
    play: function () {
      var audioEl = this.$el.querySelector('audio');
      if (audioEl) {
        if (audioEl.paused) {
          audioEl.play();
          this.tooltip = 'Pause';
        } else {
          audioEl.pause();
          this.tooltip = 'Play';
        }
      }
    },
    changeState: function () {
      var comp = this;
      setTimeout(function () {
        var audioEl = comp.$el.querySelector('audio');
        if (audioEl) {
          comp.tooltip = audioEl.paused ? 'Play' : 'Pause';
        }
      }, 50);
    }
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function () {
    return {
      playing: false,
      playClass: 'preview'
    };
  },
  props: {
    media: {},
    current: ''
  },
  methods: {
    togglePlaymode: function () {
      this.playing = !this.playing;
      var comp = this;
      this.$on('media', function (uri) {
        if (uri !== this.media.uri) {
          comp.playing = false;
        }
      });
      if (this.playing) {
        if (this.media.uri) {
          this.$parent.mediaPlaying = this.media.uri;
        }
      }
    }
  },
  watch: {
    current: function () {
      if (this.current !== this.media.uri) {
        this.playing = false;
      }
    },
    playing: function () {
      this.playClass = this.playing ? 'playing' : 'preview';
    }
  }
});

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    imgset: {},
    sizes: {},
    className: ''
  },
  mounted: function () {
    if (typeof window.picturefill === 'function') {
      if (window.picturefill && !this.$parent.fillPicCalled) {
        window.picturefill();
        this.$parent.fillPicCalled = true;
        var cmp = this;
        setTimeout(function () {
          cmp.$parent.fillPicCalled = false;
        }, 500);
      }
    }
  }
});

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function () {
    return {
      playing: false,
      playClass: 'preview',
      id: ''
    };
  },
  props: {
    media: {},
    current: ''
  },
  created: function () {
    if (this.media.uris instanceof Array) {
      if (this.media.uris.length > 0) {
        this.id = this.media.uris[0].src;
      }
    }
  },
  methods: {
    togglePlaymode: function () {
      this.playing = !this.playing;
      if (this.playing) {
        if (this.media.uris instanceof Array) {
          if (this.media.uris.length > 0) {
            this.$parent.mediaPlaying = this.id;
          }
        }
      }
    }
  },
  watch: {
    current: function () {
      if (this.current !== this.id) {
        this.playing = false;
      }
    },
    playing: function () {
      this.playClass = this.playing ? 'playing' : 'preview';
    }
  }
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vueisotope__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vueisotope___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vueisotope__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_images_loaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VuePicture_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VuePicture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VuePicture_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VueEmbedplayer_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VueEmbedplayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__VueEmbedplayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VueVideoplayer_vue__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__VueVideoplayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__VueVideoplayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VueAudioplayer_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VueAudioplayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__VueAudioplayer_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'work',
  directives: {
    imagesLoaded: __WEBPACK_IMPORTED_MODULE_2_vue_images_loaded___default.a
  },
  components: {
    isotope: __WEBPACK_IMPORTED_MODULE_1_vueisotope___default.a,
    VuePicture: __WEBPACK_IMPORTED_MODULE_3__VuePicture_vue___default.a,
    VueEmbedplayer: __WEBPACK_IMPORTED_MODULE_4__VueEmbedplayer_vue___default.a,
    VueVideoplayer: __WEBPACK_IMPORTED_MODULE_5__VueVideoplayer_vue___default.a,
    VueAudioplayer: __WEBPACK_IMPORTED_MODULE_6__VueAudioplayer_vue___default.a
  },
  props: {
    isAdmin: false,
    winWidth: 0,
    winHeight: 0,
    prevY: 0,
    prevStopY: 0
  },
  data: function () {
    return {
      title: 'Projects',
      viewMode: 'show-listing',
      loading: false,
      slides: [],
      numSlides: 0,
      loadedMore: false,
      defaultSize: 'max_1300x1300',
      hasFullImage: false,
      showFull: false,
      prevListY: 0,
      mediaPlaying: '',
      fillPicCalled: false,
      fullNode: {
        nid: 0,
        title: '',
        body: '',
        images: [],
        sections: []
      },
      imgsLoaded: false,
      fullCaption: '',
      showFullCaption: false,
      sortMessage: '',
      shuffleMode: 'off',
      shuffleHint: 'toggle sort mode',
      pictureSizes: {
        'max_650x650': '(min-width:1301px)',
        'max_325x325': '(max-width:1300px)'
      },
      fullSizes: {
        'max_2600x2600': '(min-width:1301px)',
        'max_1300x1300': '(min-width:651px) and (max-width:1300px)',
        'max_650x650': '(min-width:326px) and (max-width:650px)',
        'max_325x325': '(max-width:325px)'
      }
    };
  },
  beforeRouteEnter: function (to, from, next) {
    next(function (vm) {
      vm.initPage();
    });
  },
  created: function () {
    window.addEventListener('hashchange', this.handlePop);
    var comp = this;
    this.$parent.$on('reload-projects', function () {
      comp.loadSlides(false, true);
    });
    this.shuffleMode = this.$parent.shuffle ? 'on' : 'off';
  },
  watch: {
    prevY: function () {
      if (this.prevY > this.prevStopY) {
        if (this.$parent.scrollY > this.winHeight / 32) {
          this.loadMoreSlides();
        }
      }
    }
  },
  methods: {
    initPage: function () {
      if (this.loading !== true) {
        this.loadSlides(false);
        if (this.$parent.infoLoaded) {
          this.loadSlides(false);
        } else {
          var comp = this;
          setInterval(function () {
            if (comp.$parent.infoLoaded && comp.loading !== true) {
              comp.loadSlides(false);
            }
          }, 200);
        }
      }
    },
    loadDetail: function () {
      var path = this.$parent.path();
      if (path) {
        if (path.length > 2) {
          this.loading = true;
          path = path.replace('#', '');
          if (path !== '/projects') {
            this.fillPicCalled = false;
            this.loadDetailNode(path);
          }
        }
      }
    },
    loadDetailNode: function (path) {
      var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(this.slides, function (slide) {
        return slide.path === path;
      });
      var comp = this;
      if (index >= 0) {
        this.showFullNode(this.slides[index]);
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight();
        }, 400);
      } else {
        var moreSlides = this.$ls.get('projects-full-more', null);
        if (moreSlides instanceof Array) {
          index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(moreSlides, function (slide) {
            return slide.path === path;
          });
          if (index >= 0) {
            comp.showFullNode(moreSlides[index], true);
          }
          this.loadSlides(true);
        }
      }
      setTimeout(function () {
        comp.loading = false;
      }, 200);
    },
    loadSlides: function (more, remote) {
      var comp = this;
      var refName = 'projects-full';
      if (more === true) {
        refName += '-more';
      } else {
        more = false;
      }
      this.loading = true;
      var slides = this.$ls.get(refName, null);
      if (this.$parent.init === true && more !== true) {
        var moreSlides = this.$ls.get(refName + '-more', null);
        if (moreSlides instanceof Array) {
          if (moreSlides.length > 0) {
            slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(slides, moreSlides);
            this.loadedMore = true;
            more = false;
          }
        }
      }
      if (slides instanceof Array) {
        if (more) {
          this.cascadeSlides(slides);
        } else {
          this.slides = slides;
          if (this.$parent.shuffle) {
            this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.shuffle(this.slides);
          }
        }
        this.numSlides = this.slides.length;
        if (more !== true) {
          setTimeout(function () {
            comp.imgsLoaded = true;
            comp.loadDetail();
            this.loading = false;
            if (more === false && this.winWidth >= 640) {
              this.$parent.scrollTo(0);
            }
            setTimeout(comp.loadMoreSlides, 2000);
          }, 1000);
        }
        setTimeout(this.layout, 1750);
      } else {
        this.$parent.addContainerClass('init-load');
        var matched = false;
        if ($preload.top_projects && more !== true && remote !== true) {
          if ($preload.top_projects.valid) {
            comp.injectSlides($preload.top_projects.items, false);
            matched = true;
          }
        }
        if (!matched) {
          this.$http.get(this.$parent.backend + 'jsonstyles/' + refName).then(function (response) {
            if (response.data.items instanceof Array) {
              comp.injectSlides(response.data.items, more);
            }
          }, function (response) {});
        }
      }
    },
    injectSlides: function (data, more) {
      var comp = this;
      this.addSlides(data, more);
      setTimeout(this.loadMoreSlides, 2000);
      if (this.$parent.shuffle && more === false) {
        this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.shuffle(this.slides);
      }

      setTimeout(function () {
        comp.$parent.removeContainerClass('init-load');
      }, 500);
      if (more === false && comp.winWidth >= 640) {
        this.$parent.scrollTo(0);
      }
    },
    loadMoreSlides: function () {
      if (this.loadedMore === false) {
        this.loadSlides(true);
        this.loadedMore = true;
      }
    },
    addSlides: function (data, more) {
      this.numSlides = data.length;
      var slides = [];
      for (var i = 0; i < this.numSlides; i++) {
        if (typeof data[i] === 'object') {
          var slide = data[i];
          slide.classNames = ['slide'];
          slide.numImages = 0;
          if (slide.images instanceof Array) {
            this.processImages(slide);
          }
          slides.push(slide);
        }
      }
      if (more === true) {
        this.cascadeSlides(slides);
        this.$ls.set('projects-full-more', slides, 24 * 60 * 60 * 1000);
      } else {
        this.slides = slides;
        this.$ls.set('projects-full', this.slides, 24 * 60 * 60 * 1000);
        more = false;
      }

      this.numSlides = this.slides.length;
      var comp = this;
      setTimeout(function () {
        comp.imgsLoaded = true;
        comp.loadDetail();
        this.loading = false;
      }, 1000);
      setTimeout(this.layout, 1750);
      this.$parent.pageHeight = comp.$parent.calcPageHeight();
    },
    cascadeSlides: function (slides) {
      var num = slides.length;
      if (num > 0) {
        var comp = this;
        for (var i = 0; i < num; i++) {
          this.slides.push(slides[i]);
          setTimeout(comp.layoutQuick, i * 100);
        }
      }
    },
    processImages: function (slide) {
      slide.numImages = slide.images.length;
      slide.hasImages = slide.numImages > 0;
      var hideIndex = -1;
      if (!slide.listing_index) {
        slide.listing_index = 0;
      }
      if (slide.listing_index < slide.numImages) {
        slide.listing_index = parseInt(slide.listing_index);
      }
      if (slide.hide_from_detail) {
        if (slide.hide_from_detail === true) {
          hideIndex = slide.listing_index;
          if (slide.numImages > 1) {
            slide.numImages -= 1;
          }
        }
      }
      for (var j = 0; j < slide.images.length; j++) {
        var cln = 'index-0 active' + j;
        var attrs = slide.images[j].attributes;
        if (j === 0) {
          cln += ' active';
        }
        attrs.className = cln;
        if (slide.images[j].sizes) {
          var sizes = slide.images[j].sizes;
          if (typeof sizes === 'object') {
            slide.images[j] = {
              sizes: sizes,
              attributes: attrs,
              type: slide.images[j].type,
              picture: slide.images[j].picture,
              show: j !== hideIndex,
              listed: slide.listing_index === j
            };
          }
        }
      }
    },
    matchEdited: function (slide) {
      var edited = this.$ls.get('editednodes');
      if (edited) {
        if (edited.total) {
          if (edited.total > 0) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(edited.nodes, function (n) {
              return parseInt(n.nid) === parseInt(slide.nid);
            });
          }
        }
      }
      return -1;
    },
    fetchEdited: function (slide, index) {
      var comp = this;
      this.$http.get(this.$parent.backend + 'jsonstyles/project-full/' + slide.nid).then(function (response) {
        if (response.data instanceof Object) {
          comp.fullNode = response.data;
          var index = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.findIndex(comp.slides, function (n) {
            return n.nid === comp.fullNode.nid;
          });
          if (index >= 0) {
            comp.slides[index] = response.data;
          }
          comp.updateFullNode();
        }
      }, function (response) {});
    },
    updateFullNode: function () {
      var slide = this.fullNode;
      this.fullNode.numImages = 0;
      this.fullNode.hasImages = false;
      this.viewMode = 'show-detail';
      if (slide.images) {
        if (this.fullNode.images instanceof Array) {
          this.fullNode.numImages = slide.images.length;
          this.fullNode.hasImages = this.fullNode.numImages > 0;
          if (this.fullNode.hasImages) {
            this.processImages(this.fullNode);
          }
        }
      }
      if (slide.sections) {
        this.fullNode.numSections = 0;
        this.fullNode.hasSections = false;
        this.addImageClasses(this.fullNode);
        if (slide.sections instanceof Array) {
          this.fullNode.numSections = slide.sections.length;
          this.fullNode.hasSections = this.fullNode.numSections > 0;
          var hasImages = false;
          if (this.fullNode.hasSections) {
            for (var i = 0; i < this.fullNode.numSections; i++) {
              if (this.fullNode.sections[i].images) {
                hasImages = this.fullNode.sections[i].images.length > 0;
                if (this.fullNode.sections[i].hasImages) {
                  this.processImages(this.fullNode.sections[i]);
                  this.addImageClasses(this.fullNode.sections[i]);
                }
              } else {
                hasImages = false;
              }
              this.fullNode.sections[i].hasImages = hasImages;
            }
          }
        }
      }
    },
    addImageClasses: function (slide) {
      slide.imageClasses = 'num-images-' + slide.numImages;
      if (slide.numImages > 1) {
        slide.imageClasses += ' has-many';
      }
      if (!slide.image_layout) {
        slide.image_layout = 'flex-row';
      }
      if (slide.numImages > 1 && slide.image_layout !== 'max-1') {
        slide.imageClasses += ' rows';
      }
      slide.imageClasses += ' ' + slide.image_layout;
    },
    showFullNode: function (slide, stopPop) {
      var index = this.matchEdited(slide);
      this.prevListY = this.$parent.scrollY;
      this.processTapClasses(-1);
      if (index < 0) {
        this.addImageClasses(slide);
        this.fullNode = slide;
        this.updateFullNode();
      } else {
        this.fetchEdited(slide);
      }
      if (stopPop !== true) {
        window.location = '#' + slide.path;
      }
    },
    hideFull: function (stopPop) {
      if (this.viewMode !== 'show-listing') {
        this.viewMode = 'show-listing';
        if (stopPop !== true) {
          window.location = '#/projects';
        }
        var comp = this;
        this.loading = true;
        setTimeout(function () {
          comp.$parent.scrollTo(comp.prevListY, 2000);
          comp.loading = false;
        }, 100);
        setTimeout(function () {
          comp.$parent.pageHeight = comp.$parent.calcPageHeight();
          comp.layout();
        }, 250);
      }
    },
    hideShowCaption: function (e) {
      var index = e.target.getAttribute('data-index');
      if (!index) {
        index = 0;
      } else {
        index = parseInt(index);
      }
      if (index < this.slides.length) {
        this.processTapClasses(index);
      }
    },
    processTapClasses: function (index) {
      if (!index && typeof index !== 'number') {
        index = -1;
      }
      var sm;
      for (var i = 0; i < this.slides.length; i++) {
        var sl = this.slides[i];
        if (sl.classNames) {
          if (sl.classNames instanceof Array) {
            var ti = sl.classNames.indexOf('tapped');
            if (ti < 0 && i === index) {
              sl.classNames.push('tapped');
              sm = sl;
            } else if (ti >= 0) {
              sl.classNames = ['slide'];
            }
          }
        }
      }
      if (sm) {
        setTimeout(function () {
          sm.classNames.push('tapped-over');
        }, 250);
      }
    },
    getOptions: function () {
      return {
        itemSelector: '.slide',
        initLayout: false,
        gutter: 0
      };
    },
    layoutQuick: function () {
      this.layout(1);
    },
    layout: function (ts) {
      var comp = this;
      if (!ts) {
        ts = 250;
      }
      setTimeout(function () {
        if (comp.$refs.cpt) {
          comp.$refs.cpt.layout('masonry');
        }
      }, ts);
    },
    toggleCaption: function () {
      this.showFullCaption = !this.showFullCaption;
    },
    handlePop: function (e) {
      if (e.oldURl !== e.newURL) {
        var path = window.location.hash;
        if (path.length > 0) {
          path = path.replace(/^#/, '');
          if (path === '/projects' || path === '#/projects' || path.length < 3) {
            this.hideFull(true);
          } else if (path.indexOf('/projects') === 0) {
            if (this.loading !== true) {
              this.loadDetailNode(path);
            }
          }
        }
      }
    },
    editNode: function (id) {
      this.$parent.adminUrl = '/node/' + id + '/edit';
    },
    addNode: function () {
      this.$parent.adminUrl = '/node/add/project';
    },
    sortSlides: function (index, dir) {
      var ni = 0;
      if (dir === 'down') {
        ni = index + 1;
      } else {
        ni = index - 1;
      }
      if (ni < 0) {
        ni = this.slides.length - 1;
      } else if (ni >= this.slides.length) {
        ni = 0;
      }
      var arr = this.slides.splice(index, 1);
      this.slides.splice(ni, 0, arr[0]);
      var comp = this;
      setTimeout(function () {
        comp.$refs.cpt.layout('masonry');
      }, 250);
    },
    saveSort: function () {
      var nids = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.slides, function (sl) {
        return sl.nid;
      });
      if (nids.length > 1) {
        var url = this.$parent.backend + 'admin/content/sort-projects?ids=' + nids.join(',');
        var shVal = this.$parent.shuffle ? '1' : '0';
        url += '&shuffle=' + shVal;
        var comp = this;
        this.$http.get(url).then(function (response) {
          if (response.data) {
            if (response.data.msg) {
              comp.sortMessage = response.data.msg;
              comp.$parent.clearLocalStorage();
              setTimeout(function () {
                comp.sortMessage = '';
              }, 5000);
            }
          }
        }, function (response) {});
      }
    },
    toggleShuffle: function () {
      this.$parent.shuffle = !this.$parent.shuffle;
      this.shuffleMode = this.$parent.shuffle ? 'on' : 'off';
      this.shuffleHint = this.$parent.shuffle ? 'Disable' : 'enable';
      this.shuffleHint += ' shuffling';
      if (this.$parent.shuffle) {
        this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.shuffle(this.slides);
      } else {
        this.slides = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.slides, [function (sl) {
          return sl.weight;
        }]);
      }
    }
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(336),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(334),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(40)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('picture', {
    class: _vm.className
  }, [_vm._l((_vm.imgset.sizes), function(img, key) {
    return [(_vm.sizes[key]) ? _c('source', {
      attrs: {
        "srcset": img,
        "media": _vm.sizes[key]
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgset.sizes.max_650x650,
      "width": _vm.imgset.attributes.width,
      "height": _vm.imgset.attributes.height
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audio-player"
  }, [(_vm.media.has_preview) ? _c('img', {
    staticClass: "preview",
    attrs: {
      "src": _vm.media.preview,
      "title": _vm.tooltip
    },
    on: {
      "click": function($event) {
        _vm.play()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('audio', {
    staticClass: "audio-control",
    attrs: {
      "controls": "",
      "autoplay": _vm.autoplay
    }
  }, _vm._l((_vm.media.uris), function(uri) {
    return _c('source', {
      attrs: {
        "src": uri.src,
        "type": uri.mimetype
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "player embed",
    class: _vm.playClass
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.togglePlaymode()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.media.preview
    }
  })]), _vm._v(" "), (_vm.playing) ? _c('iframe', {
    attrs: {
      "src": _vm.media.uri,
      "width": _vm.media.width,
      "height": _vm.media.height
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container work-container",
    class: _vm.viewMode
  }, [_c('article', {
    staticClass: "work detail-content"
  }, [_c('div', {
    staticClass: "fixed-container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon-cancel",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.hideFull()
      }
    }
  })])]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "edit-bar"
  }, [_c('div', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editNode(_vm.fullNode.nid)
      }
    }
  }, [_vm._v("Edit")])]) : _vm._e(), _vm._v(" "), (_vm.fullNode.hasImages) ? _c('div', {
    staticClass: "pictures",
    class: _vm.fullNode.imageClasses
  }, _vm._l((_vm.fullNode.images), function(img, index) {
    return (img.show) ? _c('figure', [(img.picture) ? [_c('vue-picture', {
      attrs: {
        "imgset": img,
        "sizes": _vm.fullSizes,
        "className": img.attributes.className
      }
    })] : [_c('picture', {
      staticClass: "original",
      class: img.attributes.className
    }, [_c('img', {
      attrs: {
        "src": img.sizes.orig,
        "alt": img.attributes.title,
        "width": img.attributes.width,
        "height": img.attributes.height
      }
    })])], _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(img.attributes.alt))])], 2) : _vm._e()
  })) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.fullNode.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('time', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.fullNode.date))]), _vm._v(" "), _c('h5', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.fullNode.category))])]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.fullNode.body)
    }
  }), _vm._v(" "), _vm._l((_vm.fullNode.sections), function(section, index) {
    return [_c('div', {
      staticClass: "section",
      class: 'section-' + index
    }, [(section.has_media) ? [_c('div', {
      staticClass: "media",
      class: section.media.type
    }, [(section.media.type == 'embed') ? [_c('vue-embedplayer', {
      attrs: {
        "media": section.media,
        "current": _vm.mediaPlaying
      }
    })] : _vm._e(), _vm._v(" "), (section.media.type == 'video') ? [_c('vue-videoplayer', {
      attrs: {
        "media": section.media,
        "current": _vm.mediaPlaying
      }
    })] : _vm._e(), _vm._v(" "), (section.media.type == 'audio') ? [_c('vue-audioplayer', {
      attrs: {
        "media": section.media,
        "current": _vm.mediaPlaying
      }
    })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (section.hasImages) ? [_c('div', {
      staticClass: "pictures",
      class: section.imageClasses
    }, [_vm._l((section.images), function(img, imgIndex) {
      return [_c('figure', {
        key: imgIndex
      }, [(img.picture) ? [_c('vue-picture', {
        attrs: {
          "imgset": img,
          "sizes": _vm.fullSizes,
          "className": img.attributes.className
        }
      })] : [_c('picture', {
        staticClass: "original",
        class: img.attributes.className
      }, [_c('img', {
        attrs: {
          "src": img.sizes.orig,
          "alt": img.attributes.title,
          "width": img.attributes.width,
          "height": img.attributes.height
        }
      })])], _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(img.attributes.alt))])], 2)]
    })], 2)] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(section.text)
      }
    })], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "work main-content",
    class: {
      'images-loaded': _vm.imgsLoaded
    },
    attrs: {
      "data-scroll": _vm.prevY
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "edit-bar"
  }, [_c('div', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addNode()
      }
    }
  }, [_vm._v("Add new")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "slides"
  }, [(_vm.numSlides > 0) ? _c('isotope', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded:on.progress",
      value: (_vm.layout),
      expression: "layout",
      arg: "on",
      modifiers: {
        "progress": true
      }
    }],
    ref: "cpt",
    attrs: {
      "options": _vm.getOptions(),
      "list": _vm.slides
    },
    on: {
      "sort": function($event) {
        _vm.sortOption = arguments[0]
      }
    }
  }, _vm._l((_vm.slides), function(slide, si) {
    return _c('li', {
      key: si,
      class: slide.classNames,
      attrs: {
        "data-index": si,
        "data-id": slide.nid,
        "data-path": slide.path
      }
    }, [_c('v-touch', {
      staticClass: "tap-overlay",
      attrs: {
        "tag": "div",
        "data-index": si
      },
      on: {
        "tap": _vm.hideShowCaption
      }
    }), _vm._v(" "), _c('figure', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('body'),
        expression: "'body'"
      }],
      staticClass: "pictures",
      class: 'num-images-' + slide.numImages,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showFullNode(slide)
        }
      }
    }, [_vm._l((slide.images), function(img, index) {
      return [(img.listed) ? [(img.picture) ? [_c('vue-picture', {
        attrs: {
          "imgset": img,
          "sizes": _vm.pictureSizes,
          "className": 'active'
        }
      })] : [_c('picture', {
        staticClass: "original active"
      }, [_c('img', {
        attrs: {
          "src": img.sizes.orig,
          "alt": img.attributes.title,
          "width": img.attributes.width,
          "height": img.attributes.height
        }
      })])]] : _vm._e(), _vm._v(" "), _c('figcaption', [_c('div', {
        staticClass: "inner"
      }, [_c('h4', [_vm._v(_vm._s(slide.title))]), _vm._v(" "), _c('hr', {
        staticClass: "divider"
      }), _vm._v(" "), _c('p', {
        staticClass: "category"
      }, [_vm._v(_vm._s(slide.category))])])])]
    })], 2), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
      staticClass: "sort-bar"
    }, [_c('div', {
      staticClass: "arrow up",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sortSlides(si, 'up')
        }
      }
    }, [_vm._v("↑")]), _c('div', {
      staticClass: "weight"
    }, [_vm._v(_vm._s((si + 1)))]), _c('div', {
      staticClass: "arrow down",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sortSlides(si, 'down')
        }
      }
    }, [_vm._v("↓")])]) : _vm._e()], 1)
  })) : _vm._e()], 1)]), _vm._v(" "), (_vm.isAdmin && _vm.viewMode == 'show-listing') ? _c('div', {
    staticClass: "sort-save"
  }, [(_vm.sortMessage.length > 3) ? _c('p', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.sortMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shuffle",
    attrs: {
      "title": _vm.shuffleHint
    },
    on: {
      "click": function($event) {
        _vm.toggleShuffle()
      }
    }
  }, [_vm._v("Shuffle " + _vm._s(_vm.shuffleMode))]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.saveSort()
      }
    }
  }, [_vm._v("Save sort")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "top-nav"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    attrs: {
      "id": "site-name"
    },
    on: {
      "click": function($event) {
        _vm.revealStrapline()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/projects'
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('nav', {
    staticClass: "main-nav"
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.menu), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "site-info",
    class: {
      'is-admin': _vm.isAdmin, 'show-message': _vm.showStatusMsg
    },
    on: {
      "click": function($event) {
        _vm.clearLocalStorage()
      }
    }
  }, [_c('h5', {
    staticClass: "owner"
  }, [_vm._v(_vm._s(_vm.owner))]), _vm._v(" "), _c('p', {
    staticClass: "strapline"
  }, [_vm._v(_vm._s(_vm.strapline))]), _vm._v(" "), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.menuToggle()
      }
    }
  }, [_vm._v("Menu")])])]), _vm._v(" "), _c('keep-alive', [_c('router-view', {
    attrs: {
      "is-admin": _vm.isAdmin,
      "win-width": _vm.winWidth,
      "win-height": _vm.winHeight,
      "prev-y": _vm.prevY,
      "prev-stop-y": _vm.prevStopY
    }
  })], 1), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "admin-pane",
    attrs: {
      "id": "admin-pane"
    }
  }, [_c('div', {
    staticClass: "close-admin",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeAdmin()
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), (_vm.hasAdminUrl) ? _c('iframe', {
    staticClass: "admin-frame",
    attrs: {
      "src": _vm.adminPath
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasContent) ? _c('article', {
    staticClass: "content-container node-page"
  }, [_c('h2', {
    staticClass: "article-title",
    class: {
      'show-title': _vm.showTitle, 'hide-title': !_vm.showTitle
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "edit-bar"
  }, [_c('div', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editNode(_vm.content.nid)
      }
    }
  }, [_vm._v("Edit")])]) : _vm._e(), _vm._v(" "), (_vm.content.hasImage) ? [_c('vue-picture', {
    attrs: {
      "imgset": _vm.content.image,
      "sizes": _vm.fullSizes,
      "className": _vm.content.image.attributes.className
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content.body)
    }
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "player video",
    class: _vm.playClass
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.togglePlaymode()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.media.preview
    }
  })]), _vm._v(" "), (_vm.playing) ? _c('video', {
    attrs: {
      "controls": "",
      "autoplay": ""
    }
  }, _vm._l((_vm.media.uris), function(uri) {
    return _c('source', {
      attrs: {
        "src": uri.src,
        "type": uri.mimetype
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 345:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[129]);


// WEBPACK FOOTER //
// static/js/app.8b44acfd1c0c0e4bdfae.js